import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './Policies.css';

const DLAs = () => {
  const dlas = [
    {
      name: 'SnapPaisa',
      url: 'https://www.snappaisa.com/',
      logo: '/logo-snap.png'
    },
    {
      name: 'FastPaise',
      url: 'https://fastpaise.in/',
      logo: '/logo-fastpaise.png'
    },
    {
      name: 'F1 Speed Loan',
      url: 'https://f1speedloan.com/',
      logo: '/logo-f1speedloan.png'
    },
    {
      name: 'Salaryadda',
      url: 'https://salaryadda.com/',
      logo: '/logo-salaryadda.png'
    },
    {
      name: 'Salarysetu',
      url: 'https://salarysetu.com/',
      logo: '/logo-salarysetu.png'
    }
  ];

  return (
    <div className="policies-page">
      <section className="policies-banner">
        <div className="policies-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">DLAs</h2>
          </div>
        </div>
      </section>

      <section className="policies-content">
        <div className="policies-wrapper">
          <div className="policies-list">
            {dlas.map((dla) => (
              <a
                key={dla.name}
                href={dla.url}
                target="_blank"
                rel="noopener noreferrer"
                className="policy-item policy-cta"
              >
                <div className="policy-logo-wrap">
                  <img src={dla.logo} alt={`${dla.name} logo`} className="policy-logo" />
                </div>
                <div className="policy-details">
                  <div className="policy-name">{dla.name}</div>
                  <div className="policy-link-url">{dla.url}</div>
                </div>
                <div className="policy-arrow">↗</div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DLAs;
